/* eslint-disable react/display-name,complexity */
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Icon, Container, Typography } from '../';
import * as S from './styles';
export var Checkbox = forwardRef(function Checkbox(props, ref) {
    var id = props.id, name = props.name, disabled = props.disabled, variant = props.variant, label = props.label, color = props.color, required = props.required, checkboxValue = props.checkboxValue, onChange = props.onChange, value = props.value, className = props.className, style = props.style;
    var onChangeHandler = function (event) {
        if (onChange)
            onChange(event, !value);
    };
    var colorClass = color + "-color";
    var variantClass = variant + "-variant";
    var disabledClass = disabled ? 'is-disabled' : false;
    var isClickableClass = onChange ? 'is-clickable' : false;
    var isActiveClass = value ? 'is-active' : 'is-empty';
    var isColoredClass = variant === 'radioColored' ? 'is-colored' : false;
    var wrapperClass = cx(disabledClass, isClickableClass, variantClass, className);
    var radioVariantClass = cx(variantClass, isActiveClass, colorClass, isColoredClass);
    return (React.createElement(S.CheckboxWrapper, { htmlFor: id, className: wrapperClass },
        React.createElement(S.CheckboxInput, { id: id, name: name, disabled: disabled, required: required, onChange: onChangeHandler, checked: value, value: checkboxValue, style: style, ref: ref, type: 'checkbox' }),
        React.createElement(Container, null, variant === 'checkbox' ? (React.createElement(Icon, { as: 'link', className: 'checkbox-svg', name: value ? 'checkboxActive' : 'checkboxEmpty' })) : (React.createElement(S.RadioVariant, { className: radioVariantClass }, variant === 'radioColored' && value && React.createElement(Icon, { as: 'link', name: 'check', color: 'white', size: 17 })))),
        label && (React.createElement(Container, { left: 'xsmall' },
            React.createElement(Typography, { as: 'span', color: disabled ? 'light' : undefined }, label)))));
});
Checkbox.defaultProps = {
    disabled: false,
    color: 'black',
    variant: 'checkbox'
};
Checkbox.displayName = 'Checkbox';
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map